import { type FC } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as CalendarCheckIcon } from 'assets/icons/menu-icons/calendar-check.svg';
import { selectProfile } from 'store/profile-reducer/profile.selectors';

import { useCart } from 'components/logic/Cart/hooks/useCart';
import { gtmClickStartTrial } from 'utils/gtmSender/gtmSender';

import * as S from './TrialMinerLink.styled';

interface IPropsTrialMinerLink {
  t: (key: string) => string;
}

export const TrialMinerLink: FC<IPropsTrialMinerLink> = ({ t }) => {
  const { hasTrial } = useSelector(selectProfile);
  const { handleTrialCheckoutClick } = useCart();

  if (hasTrial === undefined || hasTrial) {
    return null;
  }

  return (
    <S.TrialMinerLink
      onClick={() => {
        gtmClickStartTrial('start_trial_menu_button');
        handleTrialCheckoutClick();
      }}
    >
      <CalendarCheckIcon />
      {t('menu.buyAntminerS21Trial')}
    </S.TrialMinerLink>
  );
};
